import { Language } from "@/Common/Models/Domain/Language";

import { isValidString } from "@/Utils/String";

export const isValidLanguage = (language: unknown): language is Language => {
  return isValidString(language) && Object.values(Language).includes(language as Language);
};

export const navigatorLang = isValidLanguage(navigator.language.substring(0, 2))
  ? (navigator.language.substring(0, 2) as Language)
  : Language.ENGLISH;
